
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/karte",
      function () {
        return require("private-next-pages/karte/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/karte"])
      });
    }
  